import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolbarHelperService {

  toolbarMain(entityId: number) {
    const mainConfig = 'toolbar=empty';
    return [mainConfig, 'edit?entityId=' + entityId, 'new?contentType=Download'];
  }

  toolbarEditDownload(entityId: string, title: string, entityGuid: string) {
    const mainConfig = 'toolbar=empty';
    return [mainConfig, 'edit?entityId=' + entityId, 'delete?entityGuid=' + entityGuid + '&entityId=' + entityId + '&title=' + encodeURIComponent(title)];
  }

  toolbarAddDownload() {
    const mainConfig = 'toolbar=empty';
    return [mainConfig, 'new?contentType=Download'];
  }

}
